import React, { useEffect, useRef, useState } from 'react'

interface DeferredMountProps {
  children: React.ReactNode
  rootMargin?: string
  placeholder?: React.ReactNode
}

const DeferredMount: React.FC<DeferredMountProps> = ({
  children,
  rootMargin = '200px',
  placeholder = null,
}) => {
  const ref = useRef<HTMLDivElement>(null)
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    if (mounted) return undefined

    const element = ref.current
    if (!element) return undefined

    if (!('IntersectionObserver' in window)) {
      setMounted(true)
      return undefined
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setMounted(true)
          observer.disconnect()
        }
      },
      { rootMargin }
    )

    observer.observe(element)
    return () => observer.disconnect()
  }, [mounted, rootMargin])

  return <div ref={ref}>{mounted ? children : placeholder}</div>
}

export default DeferredMount
